export default __webpack_public_path__ + "static/media/SensorCalfLeft.a4609dbd.svg";